import 'es6-promise/auto';

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '../public/styles.css'

/**
 * @TODO
 * Unfortunately importing from libphonenumber-js in Vue files doesn't work,
 * so we have to use the global namespace as workaround. See TelephoneInput
 *
 * One thing to try would be to create a wrapper library in a separate file.
 */
import {parsePhoneNumberFromString, getExtPrefix, AsYouType} from 'libphonenumber-js';
window.getExtPrefix = getExtPrefix;
window.parsePhoneNumberFromString = parsePhoneNumberFromString;
window.phoneFormatter = AsYouType;

//import './assets/css/weblication.css'
import './assets/css/registration.css'
import examples from 'libphonenumber-js/examples.mobile.json';
import { getExampleNumber } from 'libphonenumber-js';
window.getExampleNumber = (country) => getExampleNumber(country, examples);

import './fa-import';

new Vue({
  router,
  data : {
    store
  },
  render: h => h(App)
}).$mount('#app');
